<template>
  <teleport to="body">
    <div
      v-if="isOpen"
      class="overlay"
      @mousedown.self="close"
      v-bind="$attrs"
    >
      <div
        class="modal"
      >
        <div
          class="modal__close"
          @click="close"
        >
          &#10006;
        </div>
        <slot />
      </div>
    </div>
  </teleport>
</template>

<script>
export default {
  name: 'AppModal',
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    open () {
      this.isOpen = true
    },
    close () {
      this.isOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
.overlay {
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(8px);
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .modal {
    background: rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(80px);
    padding: 40px 30px;
    border-radius: 32px;
    position: relative;
    min-width: 500px;

    &__close {
      position: absolute;
      font-size: 24px;
      top: -20px;
      right: -20px;

      &:hover {
        color: red;
        cursor: pointer;
      }
    }
  }
}
</style>
